import crypto from "crypto-js";

class SecureStorage {
    constructor() {
        this.secretKey = this.getOrCreateSecretKey();
    }

    setItem(key, value) {
        try {
            const encryptedValue = crypto.AES.encrypt(value, this.secretKey).toString();
            localStorage.setItem(key, encryptedValue);
        } catch (error) {
            console.error("Failed to encrypt value: ", error);
        }
    }

    getItem(key) {
        try {
            const encryptedValue = localStorage.getItem(key);
            if (!encryptedValue) return null;

            const value = crypto.AES.decrypt(encryptedValue, this.secretKey);
            return value.toString(crypto.enc.Utf8);
        } catch (error) {
            console.error("Token decryption failed: ", error);
            this.clearItem(key);
            return null;
        }
    }

    clearItem(key) {
        localStorage.removeItem(key);
        sessionStorage.removeItem('secret_key');
    }

    getOrCreateSecretKey() {
        let key = sessionStorage.getItem('secret_key');
        if (!key) {
            key = crypto.lib.WordArray.random(32).toString();
            sessionStorage.setItem('secret_key', key);
        }
        return key;
    }

    encrypt(value) {
        try {
            const encryptedValue = crypto.AES.encrypt(value, this.secretKey).toString();
            return encryptedValue;
        } catch (error) {
            console.error("Value encryption failed: ", error);
            return null;
        }
    }

    decrypt(encryptedValue) {
        try {
            const value = crypto.AES.decrypt(encryptedValue, this.secretKey);
            return value.toString(crypto.enc.Utf8);
        } catch (error) {
            console.error("Value decryption failed: ", error);
            return null;
        }
    }
}

export const cryptoStorage = new SecureStorage();